/**
 * Client-side authentication data used by the {@link IAuthenticationClient} during authentication handshake.
 */
export class AuthenticationData {
}
//# sourceMappingURL=data.js.map